import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData from "../animation-data/parent-area/data_web.json";

function StatisticsAnimationMobile() {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.getElementById('parent-area-animation-desktop'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData,
      progressiveLoad: true,
      rendererSettings: {
        preserveAspectRatio: 'xMaxYMid slice'
      }
    });
  },[])

  return (
    <div id="parent-area-animation-desktop"></div>
  )
}

export default StatisticsAnimationMobile;